var map = {
	"./": 18305,
	"./App": 9555,
	"./App.css": 93508,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./components/DispatchMessage/DispatchMessage": 63129,
	"./components/DispatchMessage/DispatchMessage.js": 63129,
	"./components/DispatchMessage/DispatchMessage.module.css": 73976,
	"./components/ImageBuilder/ImageBuilder": 29669,
	"./components/ImageBuilder/ImageBuilder.js": 29669,
	"./components/ImageBuilder/image-builder.css": 52311,
	"./components/Options/CategoryPlate/CategoryPlate": 60753,
	"./components/Options/CategoryPlate/CategoryPlate.js": 60753,
	"./components/Options/Popups/BadgePopup/BadgePopup": 70784,
	"./components/Options/Popups/BadgePopup/BadgePopup.js": 70784,
	"./components/Options/Popups/BorderOptions/BorderOptions": 31892,
	"./components/Options/Popups/BorderOptions/BorderOptions.js": 31892,
	"./components/Options/Popups/BorderOptions/border-options.css": 70337,
	"./components/Options/Popups/ColorPicker/ColorPicker": 46107,
	"./components/Options/Popups/ColorPicker/ColorPicker.js": 46107,
	"./components/Options/Popups/ColorPicker/color-picker.css": 55688,
	"./components/Options/Popups/CustomBadgePopup/CustomBadgePopup": 4962,
	"./components/Options/Popups/CustomBadgePopup/CustomBadgePopup.js": 4962,
	"./components/Options/Popups/CustomBadgePopup/iconsBadge": 64077,
	"./components/Options/Popups/CustomBadgePopup/iconsBadge.js": 64077,
	"./components/Options/Popups/FontStylePopup/FontStylePopup": 15069,
	"./components/Options/Popups/FontStylePopup/FontStylePopup.js": 15069,
	"./components/Options/Popups/MaterialPopup/MaterialPopup": 54446,
	"./components/Options/Popups/MaterialPopup/MaterialPopup.js": 54446,
	"./components/Options/Popups/OptionPopup": 21179,
	"./components/Options/Popups/OptionPopup.js": 21179,
	"./components/Options/Popups/SizePopup/SizePopup": 96270,
	"./components/Options/Popups/SizePopup/SizePopup.js": 96270,
	"./components/Options/Popups/SloganPopup/SloganPopup": 97774,
	"./components/Options/Popups/SloganPopup/SloganPopup.js": 97774,
	"./components/Options/Popups/option-popup.css": 54364,
	"./components/Options/SelectOption/SelectOption": 93829,
	"./components/Options/SelectOption/SelectOption.js": 93829,
	"./components/Options/TypeOfTransport/TypeOfTransport": 85734,
	"./components/Options/TypeOfTransport/TypeOfTransport.js": 85734,
	"./components/Options/option-box.css": 84777,
	"./components/Options/radio-buttons.css": 24153,
	"./components/PlateOptions/PlateOptions": 5641,
	"./components/PlateOptions/PlateOptions.js": 5641,
	"./components/PlateOptions/PlateOptions.module.css": 37407,
	"./components/PositionPlate/PositionPlate": 2814,
	"./components/PositionPlate/PositionPlate.js": 2814,
	"./components/RegistrationName/RegistrationName": 49498,
	"./components/RegistrationName/RegistrationName.js": 49498,
	"./components/RegistrationName/RegistrationName.module.css": 5289,
	"./components/ResultPrice/ResultPrice": 61286,
	"./components/ResultPrice/ResultPrice.js": 61286,
	"./components/ResultPrice/ResultPrice.module.css": 38682,
	"./components/UI/ErrorMessage.module.css": 65090,
	"./components/UI/ErrorModal": 73294,
	"./components/UI/ErrorModal.js": 73294,
	"./getPlateBuilderData": 38052,
	"./getPlateBuilderData.js": 38052,
	"./img/CARBON-PATTERN.jpg": 71794,
	"./img/HONEYCOMB-PATTERN.png": 49113,
	"./img/arrow.png": 85251,
	"./img/badge.png": 74835,
	"./img/badges/SHOW-PLATES-BADGES_ANGRY-SHEEP.svg": 45096,
	"./img/badges/SHOW-PLATES-BADGES_AQUARIUS-ICON.svg": 38242,
	"./img/badges/SHOW-PLATES-BADGES_AQUARIUS.svg": 15231,
	"./img/badges/SHOW-PLATES-BADGES_ARIES-ICON.svg": 76511,
	"./img/badges/SHOW-PLATES-BADGES_ARIES.svg": 16131,
	"./img/badges/SHOW-PLATES-BADGES_AUSTRAILIA.svg": 46659,
	"./img/badges/SHOW-PLATES-BADGES_CANADA.svg": 70395,
	"./img/badges/SHOW-PLATES-BADGES_CANCER-ICON.svg": 46194,
	"./img/badges/SHOW-PLATES-BADGES_CANCER.svg": 8362,
	"./img/badges/SHOW-PLATES-BADGES_CANNABIS-LEAF.svg": 27633,
	"./img/badges/SHOW-PLATES-BADGES_CAPRICORN-ICON.svg": 21382,
	"./img/badges/SHOW-PLATES-BADGES_CAPRICORN.svg": 40890,
	"./img/badges/SHOW-PLATES-BADGES_CHINA.svg": 29586,
	"./img/badges/SHOW-PLATES-BADGES_CONSERVATIVE.svg": 46501,
	"./img/badges/SHOW-PLATES-BADGES_CORNWALL-P.svg": 96947,
	"./img/badges/SHOW-PLATES-BADGES_CORNWALL.svg": 79883,
	"./img/badges/SHOW-PLATES-BADGES_DEVIL-BLACK.svg": 24590,
	"./img/badges/SHOW-PLATES-BADGES_DEVIL-RED.svg": 78559,
	"./img/badges/SHOW-PLATES-BADGES_ECO.svg": 28682,
	"./img/badges/SHOW-PLATES-BADGES_ENGLAND-ROSE.svg": 10582,
	"./img/badges/SHOW-PLATES-BADGES_GB-EURO.svg": 9728,
	"./img/badges/SHOW-PLATES-BADGES_GB-UNION-FLAG.svg": 14089,
	"./img/badges/SHOW-PLATES-BADGES_GEMINI-ICON.svg": 51926,
	"./img/badges/SHOW-PLATES-BADGES_GEMINI.svg": 88469,
	"./img/badges/SHOW-PLATES-BADGES_GUERNSEY.svg": 23547,
	"./img/badges/SHOW-PLATES-BADGES_INDIA.svg": 72248,
	"./img/badges/SHOW-PLATES-BADGES_IOM-L.svg": 17542,
	"./img/badges/SHOW-PLATES-BADGES_IOM-p.svg": 20675,
	"./img/badges/SHOW-PLATES-BADGES_IOW.svg": 68808,
	"./img/badges/SHOW-PLATES-BADGES_IRL.svg": 74271,
	"./img/badges/SHOW-PLATES-BADGES_JAMAICA.svg": 96777,
	"./img/badges/SHOW-PLATES-BADGES_JAPAN.svg": 6300,
	"./img/badges/SHOW-PLATES-BADGES_JERSEY-GREEN.svg": 68216,
	"./img/badges/SHOW-PLATES-BADGES_JERSEY_BLUE.svg": 7197,
	"./img/badges/SHOW-PLATES-BADGES_JERSEY_WHITE-1.svg": 98787,
	"./img/badges/SHOW-PLATES-BADGES_JERSEY_WHITE.svg": 81061,
	"./img/badges/SHOW-PLATES-BADGES_LABOUR.svg": 95029,
	"./img/badges/SHOW-PLATES-BADGES_LEO-ICON.svg": 12614,
	"./img/badges/SHOW-PLATES-BADGES_LEO.svg": 53606,
	"./img/badges/SHOW-PLATES-BADGES_LIB-DEM.svg": 45555,
	"./img/badges/SHOW-PLATES-BADGES_LIBRA-ICON.svg": 71172,
	"./img/badges/SHOW-PLATES-BADGES_LIBRA.svg": 21429,
	"./img/badges/SHOW-PLATES-BADGES_PAKISTAN.svg": 95054,
	"./img/badges/SHOW-PLATES-BADGES_PEACE-LINE.svg": 82124,
	"./img/badges/SHOW-PLATES-BADGES_PEACE.svg": 57476,
	"./img/badges/SHOW-PLATES-BADGES_PISCES-ICON.svg": 92274,
	"./img/badges/SHOW-PLATES-BADGES_PISCES.svg": 44627,
	"./img/badges/SHOW-PLATES-BADGES_POLAND.svg": 6458,
	"./img/badges/SHOW-PLATES-BADGES_REAPER.svg": 48590,
	"./img/badges/SHOW-PLATES-BADGES_ROI.svg": 80827,
	"./img/badges/SHOW-PLATES-BADGES_SAGITTARIUS-ICON.svg": 58371,
	"./img/badges/SHOW-PLATES-BADGES_SAGITTARIUS.svg": 19850,
	"./img/badges/SHOW-PLATES-BADGES_SCORPIO-ICON.svg": 67431,
	"./img/badges/SHOW-PLATES-BADGES_SCORPIO.svg": 69974,
	"./img/badges/SHOW-PLATES-BADGES_SOUTH-AFRICA.svg": 58088,
	"./img/badges/SHOW-PLATES-BADGES_TAURUS-ICON.svg": 84835,
	"./img/badges/SHOW-PLATES-BADGES_TAURUS.svg": 71494,
	"./img/badges/SHOW-PLATES-BADGES_UK-EURO.svg": 92523,
	"./img/badges/SHOW-PLATES-BADGES_USA.svg": 7816,
	"./img/badges/SHOW-PLATES-BADGES_VIKING.svg": 32030,
	"./img/badges/SHOW-PLATES-BADGES_VIRGO-ICON.svg": 35176,
	"./img/badges/SHOW-PLATES-BADGES_VIRGO.svg": 3168,
	"./img/badges/STANDARD BADGES_green_BGRND_CYMRU_L.svg": 40740,
	"./img/badges/STANDARD BADGES_green_BGRND_CYMRU_P.svg": 34074,
	"./img/badges/STANDARD BADGES_green_BGRND_ENG L.svg": 28450,
	"./img/badges/STANDARD BADGES_green_BGRND_ENGLAND_L.svg": 35514,
	"./img/badges/STANDARD BADGES_green_BGRND_ENGLAND_P.svg": 93107,
	"./img/badges/STANDARD BADGES_green_BGRND_ENG_P.svg": 71353,
	"./img/badges/STANDARD BADGES_green_BGRND_EV_GREEN.svg": 27404,
	"./img/badges/STANDARD BADGES_green_BGRND_NI_L.svg": 82238,
	"./img/badges/STANDARD BADGES_green_BGRND_NI_P.svg": 47773,
	"./img/badges/STANDARD BADGES_green_BGRND_NORTHERN_IRE_L.svg": 34845,
	"./img/badges/STANDARD BADGES_green_BGRND_NORTHERN_IRE_P.svg": 23050,
	"./img/badges/STANDARD BADGES_green_BGRND_SCOTLAND_L.svg": 11507,
	"./img/badges/STANDARD BADGES_green_BGRND_SCOTLAND_P.svg": 40385,
	"./img/badges/STANDARD BADGES_green_BGRND_SCO_L.svg": 62577,
	"./img/badges/STANDARD BADGES_green_BGRND_SCO_P.svg": 40311,
	"./img/badges/STANDARD BADGES_green_BGRND_UK_L.svg": 26587,
	"./img/badges/STANDARD BADGES_green_BGRND_UK_P.svg": 90508,
	"./img/badges/STANDARD BADGES_green_BGRND_UNITED KINGDOM_L.svg": 45628,
	"./img/badges/STANDARD BADGES_green_BGRND_UNITED KINGDOM_P.svg": 72306,
	"./img/badges/STANDARD BADGES_green_BGRND_WALES_L.svg": 54136,
	"./img/badges/STANDARD BADGES_green_BGRND_WALES_P.svg": 12466,
	"./img/badges/STANDARD_BADGES_green_BGRND_CYMRU_L.svg": 91661,
	"./img/badges/STANDARD_BADGES_green_BGRND_CYMRU_P.svg": 41261,
	"./img/badges/STANDARD_BADGES_green_BGRND_ENGLAND_L.svg": 43893,
	"./img/badges/STANDARD_BADGES_green_BGRND_ENGLAND_P.svg": 10787,
	"./img/badges/STANDARD_BADGES_green_BGRND_ENG_L.svg": 61040,
	"./img/badges/STANDARD_BADGES_green_BGRND_ENG_P.svg": 98743,
	"./img/badges/STANDARD_BADGES_green_BGRND_EV_GREEN.svg": 9154,
	"./img/badges/STANDARD_BADGES_green_BGRND_NI_L.svg": 20698,
	"./img/badges/STANDARD_BADGES_green_BGRND_NI_P.svg": 50266,
	"./img/badges/STANDARD_BADGES_green_BGRND_NORTHERN_IRE_L.svg": 61462,
	"./img/badges/STANDARD_BADGES_green_BGRND_NORTHERN_IRE_P.svg": 69965,
	"./img/badges/STANDARD_BADGES_green_BGRND_SCOTLAND_L.svg": 93118,
	"./img/badges/STANDARD_BADGES_green_BGRND_SCOTLAND_P.svg": 68795,
	"./img/badges/STANDARD_BADGES_green_BGRND_SCO_L.svg": 48252,
	"./img/badges/STANDARD_BADGES_green_BGRND_SCO_P.svg": 39089,
	"./img/badges/STANDARD_BADGES_green_BGRND_UK_L.svg": 28361,
	"./img/badges/STANDARD_BADGES_green_BGRND_UK_P.svg": 30339,
	"./img/badges/STANDARD_BADGES_green_BGRND_UNITED_KINGDOM_L.svg": 70347,
	"./img/badges/STANDARD_BADGES_green_BGRND_UNITED_KINGDOM_P.svg": 55238,
	"./img/badges/STANDARD_BADGES_green_BGRND_WALES_L.svg": 1518,
	"./img/badges/STANDARD_BADGES_green_BGRND_WALES_P.svg": 27163,
	"./img/badges/badge1.svg": 7549,
	"./img/badges/badge10.svg": 62239,
	"./img/badges/badge11.svg": 49821,
	"./img/badges/badge12.svg": 33536,
	"./img/badges/badge13.svg": 26816,
	"./img/badges/badge14.svg": 5795,
	"./img/badges/badge15.svg": 82990,
	"./img/badges/badge16.svg": 94530,
	"./img/badges/badge17.svg": 31422,
	"./img/badges/badge18.svg": 3455,
	"./img/badges/badge19.svg": 90130,
	"./img/badges/badge2.svg": 53602,
	"./img/badges/badge20.svg": 66242,
	"./img/badges/badge3.svg": 49221,
	"./img/badges/badge4.svg": 82907,
	"./img/badges/badge5.svg": 25035,
	"./img/badges/badge6.svg": 83780,
	"./img/badges/badge7.svg": 76896,
	"./img/badges/badge8.svg": 7522,
	"./img/badges/badge9.svg": 11011,
	"./img/border.png": 46034,
	"./img/car-bg.png": 18795,
	"./img/colorize/1.svg": 64221,
	"./img/colorize/10.svg": 16452,
	"./img/colorize/11.svg": 22129,
	"./img/colorize/12.svg": 75156,
	"./img/colorize/13.svg": 15311,
	"./img/colorize/14.svg": 37518,
	"./img/colorize/15.svg": 16272,
	"./img/colorize/16.svg": 57232,
	"./img/colorize/17.svg": 83561,
	"./img/colorize/18.svg": 73166,
	"./img/colorize/19.svg": 68287,
	"./img/colorize/2.svg": 49877,
	"./img/colorize/20.svg": 32982,
	"./img/colorize/21.svg": 94060,
	"./img/colorize/22.svg": 4190,
	"./img/colorize/23.svg": 60808,
	"./img/colorize/24.svg": 42994,
	"./img/colorize/25.svg": 8344,
	"./img/colorize/26.svg": 24657,
	"./img/colorize/27.svg": 87513,
	"./img/colorize/28.svg": 25844,
	"./img/colorize/29.svg": 80417,
	"./img/colorize/3.svg": 41053,
	"./img/colorize/30.svg": 7755,
	"./img/colorize/31.svg": 17420,
	"./img/colorize/32.svg": 36905,
	"./img/colorize/33.svg": 99215,
	"./img/colorize/34.svg": 50081,
	"./img/colorize/35.svg": 74423,
	"./img/colorize/36.svg": 74309,
	"./img/colorize/37.svg": 7002,
	"./img/colorize/38.svg": 2329,
	"./img/colorize/39.svg": 76385,
	"./img/colorize/4.svg": 76255,
	"./img/colorize/40.svg": 88964,
	"./img/colorize/41.svg": 64630,
	"./img/colorize/42.svg": 44703,
	"./img/colorize/43.svg": 33223,
	"./img/colorize/44.svg": 65813,
	"./img/colorize/45.svg": 58381,
	"./img/colorize/46.svg": 77766,
	"./img/colorize/47.svg": 85733,
	"./img/colorize/48.svg": 15012,
	"./img/colorize/49.svg": 99152,
	"./img/colorize/5.svg": 96620,
	"./img/colorize/50.svg": 11433,
	"./img/colorize/51.svg": 58562,
	"./img/colorize/52.svg": 39027,
	"./img/colorize/53.svg": 48542,
	"./img/colorize/54.svg": 28271,
	"./img/colorize/55.svg": 81950,
	"./img/colorize/56.svg": 38156,
	"./img/colorize/57.svg": 60258,
	"./img/colorize/58.svg": 54011,
	"./img/colorize/59.svg": 56085,
	"./img/colorize/6.svg": 68980,
	"./img/colorize/7.svg": 6664,
	"./img/colorize/8.svg": 4461,
	"./img/colorize/9.svg": 58698,
	"./img/dispatch.png": 40950,
	"./img/flag.png": 87951,
	"./img/flags/AUSTRALIA.svg": 40909,
	"./img/flags/CANADA.svg": 46340,
	"./img/flags/CHINA.svg": 54243,
	"./img/flags/CORWALL_FLAG.svg": 43936,
	"./img/flags/ENGLAND.svg": 28050,
	"./img/flags/EURO_STARS.svg": 95320,
	"./img/flags/GUERNSEY.svg": 49231,
	"./img/flags/INDIA.svg": 91460,
	"./img/flags/IOM.svg": 62911,
	"./img/flags/IOW.svg": 79754,
	"./img/flags/IRELAND.svg": 30192,
	"./img/flags/JAMAICA.svg": 55013,
	"./img/flags/JAPAN.svg": 43796,
	"./img/flags/JERSEY.svg": 8721,
	"./img/flags/JERSEY_COAT_OF_ARMS.svg": 48123,
	"./img/flags/NI.svg": 29705,
	"./img/flags/PAKISTAN.svg": 35457,
	"./img/flags/POLAND.svg": 85059,
	"./img/flags/SCOTLAND.svg": 16070,
	"./img/flags/SOUTH-AFRICA.svg": 963,
	"./img/flags/UNION_FLAG.svg": 54470,
	"./img/flags/UNION_JACK.svg": 99094,
	"./img/flags/USA.svg": 24314,
	"./img/flags/WALES.svg": 75563,
	"./img/flags/jack.svg": 64336,
	"./img/font-style.png": 71682,
	"./img/font/3DGEL.jpg": 4684,
	"./img/font/4D.jpg": 9502,
	"./img/font/IMAGE_PLACEHOLDER.jpg": 298,
	"./img/font/STANDARD.jpg": 32121,
	"./img/material.png": 14568,
	"./img/materials/HONEYCOMB.jpg": 54254,
	"./img/materials/IMAGE_PLACEHOLDER.jpg": 924,
	"./img/other.png": 52831,
	"./img/others/DEVIL.svg": 88206,
	"./img/others/ENGLAND_ROSE.svg": 94729,
	"./img/others/REAPER.svg": 39051,
	"./img/others/angry_sheep.svg": 11280,
	"./img/others/cannabis_leaf.svg": 80937,
	"./img/others/cannabis_leaf_blk.svg": 53142,
	"./img/others/cannabis_leaf_green.svg": 98187,
	"./img/others/conservative.svg": 32236,
	"./img/others/conservative_blk.svg": 3467,
	"./img/others/conservative_blue.svg": 22729,
	"./img/others/eco_plug.svg": 24991,
	"./img/others/eco_plug_blk.svg": 15912,
	"./img/others/eco_plug_green.svg": 35949,
	"./img/others/goldfish-2.svg": 50224,
	"./img/others/heart.svg": 72392,
	"./img/others/labour.svg": 10184,
	"./img/others/labour_blk.svg": 63500,
	"./img/others/labour_red.svg": 23367,
	"./img/others/lib_dem-orange.svg": 33165,
	"./img/others/lib_dem.svg": 30566,
	"./img/others/lib_dem_blk.svg": 81192,
	"./img/others/peace.svg": 43563,
	"./img/others/peace_blk.svg": 3757,
	"./img/others/peace_line.svg": 11610,
	"./img/others/peace_line_blk.svg": 90472,
	"./img/others/shark-1.svg": 44918,
	"./img/others/viking.svg": 97140,
	"./img/select.svg": 96222,
	"./img/size.png": 45494,
	"./img/slogan.png": 26426,
	"./img/sprite.svg": 25470,
	"./img/zodiac.png": 42029,
	"./img/zodiacs/aquarius.svg": 87186,
	"./img/zodiacs/aquarius_blk.svg": 8356,
	"./img/zodiacs/aquarius_icon.svg": 54887,
	"./img/zodiacs/aquarius_icon_blk.svg": 51985,
	"./img/zodiacs/aries.svg": 99889,
	"./img/zodiacs/aries_blk.svg": 85234,
	"./img/zodiacs/aries_icon.svg": 94101,
	"./img/zodiacs/aries_icon_blk.svg": 29145,
	"./img/zodiacs/cancer.svg": 40942,
	"./img/zodiacs/cancer_blk.svg": 51138,
	"./img/zodiacs/cancer_icon.svg": 83069,
	"./img/zodiacs/cancer_icon_blk.svg": 29966,
	"./img/zodiacs/capricorn.svg": 19253,
	"./img/zodiacs/capricorn_blk.svg": 920,
	"./img/zodiacs/capricorn_icon.svg": 26521,
	"./img/zodiacs/capricorn_icon_blk.svg": 46151,
	"./img/zodiacs/gemini.svg": 16570,
	"./img/zodiacs/gemini_blk.svg": 30187,
	"./img/zodiacs/gemini_icon.svg": 26530,
	"./img/zodiacs/gemini_icon_blk.svg": 24204,
	"./img/zodiacs/leo.svg": 89595,
	"./img/zodiacs/leo_blk.svg": 47098,
	"./img/zodiacs/leo_icon.svg": 5573,
	"./img/zodiacs/leo_icon_blk.svg": 60119,
	"./img/zodiacs/libra.svg": 11890,
	"./img/zodiacs/libra_blk.svg": 32624,
	"./img/zodiacs/libra_icon.svg": 11186,
	"./img/zodiacs/libra_icon_blk.svg": 71876,
	"./img/zodiacs/pisces.svg": 92289,
	"./img/zodiacs/pisces_blk.svg": 64490,
	"./img/zodiacs/pisces_icon.svg": 61892,
	"./img/zodiacs/pisces_icon_blk.svg": 87878,
	"./img/zodiacs/sagittarius.svg": 53514,
	"./img/zodiacs/sagittarius_blk.svg": 30336,
	"./img/zodiacs/sagittarius_icon.svg": 71362,
	"./img/zodiacs/sagittarius_icon_blk.svg": 86023,
	"./img/zodiacs/scorpio.svg": 88159,
	"./img/zodiacs/scorpio_blk.svg": 74251,
	"./img/zodiacs/scorpio_icon.svg": 52702,
	"./img/zodiacs/scorpio_icon_blk.svg": 12977,
	"./img/zodiacs/taurus.svg": 81633,
	"./img/zodiacs/taurus_blk.svg": 37711,
	"./img/zodiacs/taurus_icon.svg": 57992,
	"./img/zodiacs/taurus_icon_blk.svg": 88428,
	"./img/zodiacs/virgo.svg": 90322,
	"./img/zodiacs/virgo_blk.svg": 4092,
	"./img/zodiacs/virgo_icon.svg": 47467,
	"./img/zodiacs/virgo_icon_blk.svg": 53403,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./slogan": 10880,
	"./slogan.js": 10880,
	"./store/initial-plate-option": 73885,
	"./store/initial-plate-option.js": 73885,
	"./store/plate-builder-options": 53527,
	"./store/plate-builder-options.js": 53527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;